import { TProviderApi } from "@/types/Provider.types";
import { useInfinitePagination } from "../useInfinitePagination";
import { getProviders } from "@/services/api/requests/providers";
import { INFINITE_SCROLL_CARDS_PER_PAGE } from "@/constants";
import queryKeys from "@/constants/queryKeys";
import { useAppStore } from "@/store/useAppStore";

const useMYOProviderDirectory = (itemsPerPage?: number) => {
  const { user } = useAppStore();

  return useInfinitePagination<TProviderApi[]>({
    query: getProviders,
    queryKey: [queryKeys.providers.directory, user?.email ?? ''],
    limit: itemsPerPage ?? INFINITE_SCROLL_CARDS_PER_PAGE,
  });
};

export default useMYOProviderDirectory;